// extracted by mini-css-extract-plugin
module.exports = {"no-projects-message":"List_no-projects-message__3Sd5Q"};